import gql from 'graphql-tag';

export const editOrderMutation = gql`
  mutation editOrder($input: EditOrderInput!) {
    editOrder(input: $input) {
      Status
      originalValues {
        OrderType
        OrderDate
      }
    }
  }
`;
